module.exports = __webpack_public_path__ + "fonts/InstagramSans-Regular.66c28d07.woff";